import {
  ICanvasElement,
  ICanvasElementDrawArgs,
  TCanvasTextElement,
  IPositionXY,
  IFontOption
} from '@/models/marketingCenter/canvas';

class VerticalTextWrapper implements ICanvasElement {
  constructor(
    private readonly options: {
      elements: TCanvasTextElement[];
      positions: IPositionXY[];
      gapsBetween?: number[];
      fonts?: IFontOption[];
    }
  ) {}

  showOnPreview = false;

  render(
    container: HTMLDivElement,
    context: CanvasRenderingContext2D,
    args: ICanvasElementDrawArgs
  ) {
    const { elements, positions, gapsBetween, fonts = [] } = this.options;
    const instancies = elements.map(
      (Element, i) =>
        new Element({
          position: positions[i] || positions[0],
          font: fonts[i]
        })
    );

    let lastTop = 0;

    for (const [index, element] of instancies.entries()) {
      element.renderOffsetTop = lastTop;

      if (gapsBetween && gapsBetween[index - 1]) {
        element.renderOffsetTop += gapsBetween[index - 1];
      }

      if (index > 0) {
        const lineHeight =
          (fonts[index] && fonts[index].lineHeight) ||
          element.defaultValues.lineHeight;

        if (lineHeight) {
          element.renderOffsetTop += lineHeight;
        }
      }

      element.render(container, context, args);
      lastTop = element.renderNextYCoordAvailble;
    }
  }

  async draw(context: CanvasRenderingContext2D, args: ICanvasElementDrawArgs) {
    const { elements, positions, gapsBetween, fonts = [] } = this.options;
    let lastTop = 0;

    const instancies = elements.map(
      (Element, i) =>
        new Element({
          position: positions[i] || positions[0],
          font: fonts ? fonts[i] : undefined
        })
    );

    for (const [index, element] of instancies.entries()) {
      element.offsetTop =
        lastTop +
        (gapsBetween && gapsBetween[index - 1] ? gapsBetween[index - 1] : 0);

      if (index > 0) {
        const lineHeight =
          (fonts[index] && fonts[index].lineHeight) ||
          element.defaultValues.lineHeight;

        if (lineHeight) {
          element.offsetTop -= lineHeight;
        }
      }

      await element.draw(context, args);
      lastTop = element.nextYCoordAvailble;
    }
  }
}

export default VerticalTextWrapper;
